export default __webpack_public_path__ + "static/media/section3_bg.8306d443.svg";